import { TopNCardColumn } from '@/common/components/molecules/topNCard/topNCard.types';
import { AwsServiceType, AzureServiceType } from '@/config/views/platform/cloud/type/cloud.type';

export const COST_DECIMAL = 1e8;

export const SUMMARY_STAT = {
  Average: 'AVERAGE',
  Max: 'MAX',
  Min: 'MIN',
  Sum: 'SUM',
} as const;

export const TOP_ALERT_COLUMN: TopNCardColumn[] = [
  { name: 'Alarm Name', field: 'alarmName', type: 'string' },
  { name: 'Time(UTC)', field: 'time', type: 'string' },
];

export const SUMMARY_STATUS = {
  SUCCESS: 'success',
  COLLECT_OFF: 'collectOff',
  NO_PERMISSION: 'noPermission',
} as const;

export const AWS_PERIOD_ITEMS = [
  { name: 'PAST_30_MINUTES', value: 'p30m', shortName: '30m' },
  { name: 'PAST_1_HOURS', value: 'p1h', shortName: '1h' },
  { name: 'PAST_3_HOURS', value: 'p3h', shortName: '3h' },
  { name: 'PAST_6_HOURS', value: 'p6h', shortName: '6h' },
  { name: 'PAST_12_HOURS', value: 'p12h', shortName: '12h' },
  { name: 'PAST_1_DAY', value: 'p1d', shortName: '1d' },
];

export const AWS_S3_PERIOD_ITEM = [
  {
    name: 'PAST_14_DAY',
    value: 'p14d',
    shortName: '14d',
  },
  {
    name: 'PAST_31_DAY',
    value: 'p31d',
    shortName: '31d',
  },
];

export const AWS_DETAIL_METRIC_PERIOD_ITEMS = [
  { name: 'PAST_30_MINUTES', value: 'p30m', shortName: '30m' },
  { name: 'PAST_1_HOURS', value: 'p1h', shortName: '1h' },
  { name: 'PAST_3_HOURS', value: 'p3h', shortName: '3h' },
  { name: 'PAST_6_HOURS', value: 'p6h', shortName: '6h' },
  { name: 'PAST_12_HOURS', value: 'p12h', shortName: '12h' },
  { name: 'PAST_1_DAY', value: 'p1d', shortName: '1d' },
];

export const AWS_SERVICE_UNIFIED = {
  COST_EXPLORER: 'COST_EXPLORER',
  DMS: 'DMS',
  DOCUMENTDB: 'DOCUMENTDB',
  DYNAMODB: 'DYNAMODB',
  EC2: 'EC2',
  ELASTICACHE: 'ELASTICACHE',
  LAMBDA: 'LAMBDA',
  REDSHIFT: 'REDSHIFT',
  VPC: 'VPC',
};

export const AWS_SERVICE: { [key in AwsServiceType]: key } = {
  AURORA: 'AURORA',
  COST_EXPLORER: 'COST_EXPLORER',
  DMS_REPLINSTANCE: 'DMS_REPLINSTANCE',
  DMS_TASK: 'DMS_TASK',
  DOCUMENTDB: 'DOCUMENTDB',
  DYNAMODB: 'DYNAMODB',
  EC2: 'EC2',
  ECS_CLUSTER: 'ECS_CLUSTER',
  ECS_SERVICE: 'ECS_SERVICE',
  ELASTICACHE_CLUSTER: 'ELASTICACHE_CLUSTER',
  ELASTICACHE_NODE: 'ELASTICACHE_NODE',
  ELASTICACHE_SERVERLESS: 'ELASTICACHE_SERVERLESS',
  ELASTICACHE_SHARD: 'ELASTICACHE_SHARD',
  LAMBDA: 'LAMBDA',
  LIGHTSAIL_DATABASE: 'LIGHTSAIL_DATABASE',
  LIGHTSAIL_INSTANCE: 'LIGHTSAIL_INSTANCE',
  RDS: 'RDS',
  REDSHIFT: 'REDSHIFT',
  S3: 'S3',
  VPC: 'VPC',
};

export const AZURE_SERVICE: { [key in AzureServiceType]: key } = {
  // computing
  VIRTUAL_MACHINES: 'VIRTUAL_MACHINES',
  FUNCTIONS: 'FUNCTIONS',
  // storage
  BLOB_STORAGE: 'BLOB_STORAGE',
  // database
  COSMOS_DB: 'COSMOS_DB',
  CACHE_FOR_REDIS: 'CACHE_FOR_REDIS',
  CACHE_FOR_REDIS_ENTERPRISE: 'CACHE_FOR_REDIS_ENTERPRISE',
  SQL_DATABASE: 'SQL_DATABASE',
  DATABASE_FOR_POSTGRESQL: 'DATABASE_FOR_POSTGRESQL',
  DATABASE_FOR_MYSQL: 'DATABASE_FOR_MYSQL',
};

export const CLOUD_SERVICE_CATEGORY = {
  COMPUTING: [
    AWS_SERVICE.EC2,
    AWS_SERVICE.LAMBDA,
    AZURE_SERVICE.VIRTUAL_MACHINES,
    AZURE_SERVICE.FUNCTIONS,
  ],
  STORAGE: [AWS_SERVICE.S3, AZURE_SERVICE.BLOB_STORAGE],
  DATABASE: [
    AWS_SERVICE.DOCUMENTDB,
    AWS_SERVICE.DYNAMODB,
    AWS_SERVICE.ELASTICACHE_CLUSTER,
    AWS_SERVICE.ELASTICACHE_NODE,
    AWS_SERVICE.ELASTICACHE_SERVERLESS,
    AWS_SERVICE.ELASTICACHE_SHARD,
    AZURE_SERVICE.COSMOS_DB,
    AZURE_SERVICE.CACHE_FOR_REDIS,
    AZURE_SERVICE.CACHE_FOR_REDIS_ENTERPRISE,
    AZURE_SERVICE.SQL_DATABASE,
    AZURE_SERVICE.DATABASE_FOR_POSTGRESQL,
    AZURE_SERVICE.DATABASE_FOR_MYSQL,
  ],
};

// NOTE: AWS 서비스는 모두 triggerPath로 awsInfo로 오기 때문에 제외 서비스 예외 처리 필요
export const EXCLUDE_DETAIL_CATEGORY: string[] = [
  'aws_rds',
  'aws_aurora',
  'aws_ecs_cluster',
  'aws_ecs_service',
];
